import { useMutation } from '@tanstack/react-query';
import { CVSData } from '../lib/cvsdata/cvsdata';
import useAlertProvider from '../components/alert/useAlertProvider';
import { navigateBackToCallingApp } from '../lib/utils/utils';
import { UNAUTHENTICATED_STATUS_CODES } from '../lib/constants';
import { navigateToLogin } from '../lib/utils/utils';
import { useLookupErrorsTranslations } from '../lib/utils/translationHelpers';

const useCheckUsersAccount = () => {
  const { setAlerts } = useAlertProvider();
  const LOOKUP_ERRORS_TRANSLATED = useLookupErrorsTranslations();

  return useMutation({
    mutationFn: CVSData.checkUsersAccount,
    onSuccess: (res) => {
      const { isProfileLocked: isProfileLockedRes, introspect: introspectRes } = res;
      // check if access token is valid
      if (introspectRes?.statusCode === '1005' || introspectRes?.statusCode === '1006') {
        // redirect to login
        navigateToLogin();
      } else {
        // else check if users profile is locked or not
        if (
          isProfileLockedRes &&
          isProfileLockedRes?.statusCode &&
          UNAUTHENTICATED_STATUS_CODES.includes(isProfileLockedRes?.statusCode)
        ) {
          // throw tech err
          navigateToLogin();
        }
        if (isProfileLockedRes?.data) {
          const {
            data: { isProfileLockedV2 }
          } = isProfileLockedRes;
          const { statusCode, locked } = isProfileLockedV2;
          if (statusCode === '0000') {
            if (!locked) {
              return { locked: false };
            } else {
              navigateBackToCallingApp();
            }
          }
        }
      }
    },
    onError: async (error: any) => {
      setAlerts([
        {
          title: LOOKUP_ERRORS_TRANSLATED?.TECH_ERROR_TITLE,
          message: LOOKUP_ERRORS_TRANSLATED?.TECH_ERROR_DESC
        }
      ]);
    }
  });
};

export default useCheckUsersAccount;
